import i18n from 'Pods/Shared/I18n'

import threeDStudioTranslationsEN from 'Translations/ThreeDStudioEn'

// Only English is bundled statically so the initial client render (and any
// unknown locale, which falls back to English) always has a base bundle.
// Browsers load the active non-EN locale on demand via
// Translations/loadThreeDStudioLocaleBundle; SSR registers every locale
// statically via Translations/registerAllThreeDStudioLocales
// (packs/server_rendering.js). The locale files live outside Pods/ because the
// three_d_studio pack require.contexts the whole ThreeDStudio tree and would
// otherwise pull all 8 bundles back into the browser chunk.
i18n.addResourceBundle('en', 'three-d-studio', threeDStudioTranslationsEN, true, true)

export default i18n
